import React, { createContext, useState, useEffect } from 'react';
import { DarkMode, LightMode } from '../config/theme';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState('light');

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme) {
			setTheme(storedTheme);
		} else {
			const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
			setTheme(systemTheme);
		}
	}, []);

	useEffect(() => {
		const themeVariables = theme === 'dark' ? DarkMode : LightMode;
		Object.keys(themeVariables).forEach((key) => {
			document.documentElement.style.setProperty(key, themeVariables[key]);
		});
		document.documentElement.setAttribute('data-theme', theme);

		if (theme === 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
		// Save the user's theme preference
		localStorage.setItem('theme', theme);
	}, [theme]);

	const toggleTheme = () => {
		setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
	};

	return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => React.useContext(ThemeContext);
